import { liveStatsVuexGetters, LiveStatsTopics } from '@ahaslides-product/frontend-toolkit'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag, isPresentationResetAfterTurnOnFlag } from '../featureToggles.module'
import config from '@/config'
import { isClonedFromOnboardingTemplate } from '@/components-v2/onboarding/sampleFeatureBasedOptionsResponse.js'

const _getters = {
  ...liveStatsVuexGetters,

  canUseKvSyncLiveStats: (_, __, rootState, rootGetters) => {
    if (!rootState?.presentation?.id) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats') && (isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') || isPresentationResetAfterTurnOnFlag(rootState.presentation, 'kv-sync-emqx-for-live-stats'))
  },
  isClonedFromTemplateAndNotResetYet: (_, __, rootState) => {
    return isClonedFromOnboardingTemplate(rootState.presentation, rootState.presenterLocale, config.env) && !isPresentationResetAfterTurnOnFlag(rootState.presentation, 'kv-sync-emqx-for-live-stats')
  },
  canUseWordCloudEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUsePollEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseScaleEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },

  pollVoteCount: (state, getters, rootState) => {
    if (getters.canUsePollEmqx) {
      return getters.answererCountPerQuestion(rootState.slideActive.id, 0, rootState.slideActive.version)
    }
    return rootState.slideActive.multipleCountAnswer
  },
  scaleVoteCount: (state, getters, rootState) => {
    if (getters.canUseScaleEmqx) {
      return (rootState?.slideActive?.SlideOptions?.length) ? (
        Math.ceil(
          getters.answerCountPerActivity(rootState.slideActive.id, rootState.slideActive.version) /
          rootState.slideActive.SlideOptions.length,
        ))
        : 0
    }
    return rootState.slideActive.multipleCountAnswer
  },
  wordCloudVoteCount: (state, getters, rootState) => {
    if (getters.canUseWordCloudEmqx) {
      return getters.answerCountPerActivity(rootState.slideActive.id, rootState.slideActive.version)
    }
    return rootState.slideActive?.SlideOptions?.length
  },
  canUseWordCloudLiveProxy: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-wordcloud')
  },
  canUseLiveStatsForQuizV2: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'livestats-quiz-submission-v2')
  },
  canRetireLiveApi: (_, getters, ___, rootGetters) => {
    return getters.canUseLiveStatsForQuizV2 && isFeatureEnabled(rootGetters, 'retire-live-api')
  },
  canSubscribeNewKafkaCluster: (_, __, ___, rootGetters) => {
    // this flag should be turned on together with canSubmitNewLiveProxy
    return isFeatureEnabled(rootGetters, 'release-new-live-proxy')
  },
  canSubmitNewLiveProxy: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-new-live-proxy')
  },
  canGetReactionCountFromAhaSync: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-37161-use-reaction-counts-ahasync')
            && getters.canUseKvSyncLiveStats
  },
  correctAnswerCountPerActivityV2: (state) => {
    return (activityId, activityVersion) => {
      return Number(state[`categorise-v2/${LiveStatsTopics.correctAnswerCountPerActivityTopic(activityId, activityVersion)}`] || 0)
    }
  },
  canAddDeltaForAhaSync: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-37132-get-with-delta')
  },
  incorrectAnswerCountPerActivityV2: (state) => {
    return (activityId, activityVersion) => {
      return Number(state[`categorise-v2/${LiveStatsTopics.incorrectAnswerCountPerActivityTopic(activityId, activityVersion)}`] || 0)
    }
  },
  correctAnswerCountPerAnswerValueV2: (state) => {
    return (activityId, activityVersion, questionId, answerValue) => {
      return Number(state[`categorise-v2/${LiveStatsTopics.correctAnswerCountPerAnswerValueTopic(activityId, activityVersion, questionId, answerValue)}`] || 0)
    }
  },
  incorrectAnswerCountPerAnswerValueV2: (state) => {
    return (activityId, activityVersion, questionId, answerValue) => {
      return Number(state[`categorise-v2/${LiveStatsTopics.incorrectAnswerCountPerAnswerValueTopic(activityId, activityVersion, questionId, answerValue)}`] || 0)
    }
  },
  liveStatsVersionPrefix: () => {
    return config.newKafkaClusterPrefix || 'ST2'
  },
}

export default _getters
